import { decamelize } from './decamelize'

export const constantCaseify = (str: string) => decamelize(str).toUpperCase().replace(/ /g, '_')
